/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = LogOnly 1 = Challenge
 */
export type BotDetectionExecutionMode = 0 | 1;

export const BotDetectionExecutionMode = {
  LogOnly: 0 as BotDetectionExecutionMode,
  Challenge: 1 as BotDetectionExecutionMode,
};
